<template>
  <!-- <v-tooltip
    v-if="
      calculationStore.stepByStepCalculation &&
      calculationStore.currentCalculation
    "
    :text="text">
    <template v-slot:activator="{ props }">
      <span v-bind="props"
        >Calculation-Type: {{ calculationStore.currentCalculation.type }}</span
      >
    </template>
  </v-tooltip> -->
  <!-- <v-checkbox
    v-model="calculationStore.stepByStepCalculation"
    label="StepByStep Calculation" />
  <v-btn
    v-if="
      calculationStore.stepByStepCalculation || calculationStore.calculating
    "
    @click="calculationStore.calculateNext()"
    fab
    ><v-icon>mdi-debug-step-over</v-icon></v-btn
  > -->
  <span
    data-cy="currently-calculating"
    v-if="calculationStore.calculating"
    >Calculating</span
  >
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import { useCalculationStore } from "../../stores/calculationStore";
import { useSpaceStore } from "../../stores/spaceStore";

const { t } = useTranslation();
const calculationStore = useCalculationStore();
const spaceStore = useSpaceStore();

// const text = computed(() => {
//   if (calculationStore.currentCalculation) {
//     return Object.entries(calculationStore.currentCalculation.elements).reduce(
//       (result, [id, keys]) => {
//         if (!keys) {
//           return result;
//         }
//         result +=
//           spaceStore.calculationElements[id].name +
//           "\n\t{" +
//           keys.map(
//             (e) => t("entities." + id.split("_")[1] + ".fields." + e, e) + "\n"
//           ) +
//           "}\n";
//         return result;
//       },
//       ""
//     );
//   } else {
//     return "";
//   }
// });
</script>
